
import { Options, Vue } from "vue-class-component";
import { store } from "@/store";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import Paging from "@/components/Paging.vue";
import {
  readDeviceSpecsList,
  readDeviceSpecsNew,
} from "@/store/device/getters";
import {
  dispatchDeleteDevice,
  dispatchGetDeviceSpecsNew,
  dispatchUpdateDevice,
  dispatchReleaseDevice,
  dispatchupdateSystem,
} from "@/store/device/actions";
import { alert_re_chinese, getLocalProject, regChineseObJ } from "@/utils";
import { readUserProfile } from "@/store/main/getters";
import { readMyProjects } from "@/store/project/getters";
import RegisterDevice from './register-device.vue'
import axios from 'axios'
import { ElMessage } from "element-plus";

@Options({
  components: {
    SideMenu,
    Paging,
    RegisterDevice
  },
})
export default class DevicesManage extends Vue {
  handleRegisterDevice() {
    (this.$refs.registerDeviceRef as any).show()
  }

  InfoFilled = ''
  cancelEvent() {
    //
  }

  public deviceUpdateForm = {
    remark: "",
  };
  // public Level: any[] = [1, 2, 3]
  public Level: any[] = [
    { label: "1 超高端机型", value: 0 },
    { label: "2 高端机型", value: 1 },
    { label: "3 中端机型", value: 2 },
    { label: "4 低端机型", value: 3 },
    { label: "5 超低端机型", value: 4 },
  ];
  public selectSceneChange(a: any) {
    console.log(a);
  }
  // 新增设备弹窗关联字段
  public deviceRegisterForm = {
    remark: "", //序列号、备注
    UUID: "", //uuid
    Model: "", //设备型号
    level: "", //档位
  };
  public rules = {
    remark: [{ required: true, message: "请输入序列号", trigger: "blur" }],
    Model: [{ required: true, message: "请输入设备型号", trigger: "blur" }],
    level: [{ required: true, message: "请选择档位", trigger: "blur" }],
  };
  public handleUpdateForm = false;
  public handleRegisterForm = false;
  public localProject = Number(getLocalProject());

  public TaskFields1 = [
    { label: "设备型号", prop: "model" },
    { label: "设备名称", prop: "name" },
  ];
  public TaskFields2 = [
    { label: "UUID", prop: "UUID" },

    // { label: "CPU", prop: "cpu_name" },
    // { label: "CPU核数", prop: "core_num", width: "80" },
    // { label: "GPU", prop: "gpu_name" },
    // { label: "内存", prop: "ram", width: "50" },
  ];
  public TaskFields3 = [
    // { label: "UUID", prop: "UUID" },
    // { label: "厂商", prop: "oem" },
    { label: "CPU", prop: "cpu_name" },
    { label: "CPU核数", prop: "core_num", width: "80" },

    { label: "内存", prop: "ram", width: "50" },
  ];
  public search = "";
  public search1 = "";
  public record = 16; //记录条数
  public currentPage1 = 1;
  public totalNum = this.getVisitStatistics.count; //分页总数
  public loading = false;

  public async mounted() {
    this.loading = true;
    // await dispatchGetDeviceSpecsNew(store, {
    //   project: this.localProject,
    //   size: this.currentPage1,
    //   page: this.record,
    //   search: this.search1,
    // });
    await this.onPaging(this.record, 1);
    this.loading = false;
  }

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }

  // 获得记录数据
  public get getVisitStatistics() {
    return readDeviceSpecsNew(store);
  }

  // 分页
  public async onPaging(page: any, size: any) {
    this.loading = true;
    this.record = page;
    this.currentPage1 = size;

    await dispatchGetDeviceSpecsNew(store, {
      project: this.localProject,
      size: this.currentPage1,
      page: this.record,
      search: this.search1,
    });
    this.totalNum = this.getVisitStatistics.count;
    this.loading = false;
  }

  // 查询
  public async onSearch() {
    this.loading = true;
    await dispatchGetDeviceSpecsNew(store, {
      project: this.localProject,
      size: 1,
      page: this.record,
      search: this.search1,
    });
    await this.onPaging(this.record, 1);
    this.loading = false;
  }

  handleEdit(row: any, deviceUpdateForm: any) {
    if (!row.isEdit) {
      row.isEdit = !row.isEdit;
      row.handleEditText = "取消";
      row.info = "info";
      row.isDanger = "primary";
      row.handleDeleteText = "提交";
      row.handleConfirmText = "确认更改名称?";
    } else {
      row.isEdit = !row.isEdit;
      row.info = "warning";
      row.isDanger = "danger";
      row.handleEditText = "编辑";
      row.handleDeleteText = "删除";
      row.handleConfirmText = "确认删除账号?";
    }
  }
  public async handleDeleteDevice(deviceUpdateForm: any, row: any) {
    if (row.handleDeleteText === "提交") {
      const remark = (document.getElementById(row.id) as any).value;
      const remark1 = (document.getElementById("debug_url" + row.id) as any)
        .value;
      const remark2 = (document.getElementById("note" + row.id) as any).value;

      // let level = (document.getElementById("level" + row.id) as any).value;
      // if (level === "") {
      //   level = 1;
      // }

      const commitUpdateForm = {
        remark: remark,
        level: row.level,
        project: row.project,
        id: row.id,
        debug_url: remark1,
        note: remark2,
      };

      const commitUpdateSystem = {
        debug_url: remark1,
        project: row.project,
        model: row.model,
      };
      if (remark === "") {
        alert("设备名称不能为空");
        return;
      }
      if (!regChineseObJ.test(remark)) {
        alert_re_chinese("设备名称");
        return;
      }
      await dispatchUpdateDevice(store, commitUpdateForm);
      // await dispatchupdateSystem(store, commitUpdateSystem);
      await dispatchGetDeviceSpecsNew(store, {
        project: this.localProject,
        size: this.currentPage1,
        page: this.record,
        search: this.search1,
      });
    } else {
      await dispatchDeleteDevice(store, { id: row.id, project: row.project });
      await dispatchGetDeviceSpecsNew(store, {
        project: this.localProject,
        size: this.currentPage1,
        page: this.record,
        search: this.search1,
      });
      await this.onPaging(this.record, 1);
    }
  }

  get getDeviceSpecsList() {
    return readDeviceSpecsList(store);
  }
  public async release(c: any) {
    await dispatchReleaseDevice(store, {
      project: this.localProject,
      UUID: c.UUID,
    });
    await dispatchGetDeviceSpecsNew(store, {
      project: this.localProject,
      size: this.currentPage1,
      page: this.record,
      search: this.search1,
    });
  }
  public async release1(c: any) {
    window.open(c.debug_url, "_blank");
  }
  getDevices(search: string) {
    const device_list: any[] = readDeviceSpecsNew(store).results;
    for (let device of device_list) {
      Object.assign(device, device.model);
      if (!device.is_online) {
        device.status = 0;
      } else if (device.is_running) {
        device.status = 1;
      } else {
        device.status = 2;
      }
      device.isEdit = false;
      device.handleEditText = "编辑";
      device.handleDeleteText = "删除";
      device.handleConfirmText = "确定删除设备？";
      device.isDanger = "danger";
      device.info = "warning";
    }

    return device_list.filter(
      (data) =>
        !search || data.remark?.toLowerCase().includes(search.toLowerCase())
    );
  }

  // submitRegisterForm2(formName: any, deviceRegisterForm: any) {
  //   (this.$refs[formName] as Vue & { validate: any }).validate((valid: any) => {
  //     if (valid) {
  //       this.handleRegisterForm = false;
  //       deviceRegisterForm.project = this.localProject;
  //       dispatchCreateDevice(store, deviceRegisterForm);
  //       alert("submit!");
  //       this.resetUpdateForm(formName);
  //     } else {
  //       alert("error submit!!");
  //       return false;
  //     }
  //   });
  // }

  // 打开新增设备弹窗
  public handleRegisterDeviceForm() {
    this.handleRegisterForm = true;
    this.deviceRegisterForm = {
      remark: "", //序列号、备注
      UUID: "", //uuid
      Model: "", //设备型号
      level: "", //档位
    };
  }
  //关闭新增设备弹窗
  public closeRegisterDeviceForm() {
    this.handleRegisterForm = false;
  }
  // 重置
  public resetRegisterDeviceForm() {
    this.deviceRegisterForm = {
      remark: "", //序列号、备注
      UUID: "", //uuid
      Model: "", //设备型号
      level: "", //档位
    };
  }

  // 注册设备
  public async submitRegisterForm() {
    let submit = {
      project: this.localProject,
      remark: this.deviceRegisterForm.remark, //序列号、备注
      model: this.deviceRegisterForm.Model, //设备型号
      level: this.deviceRegisterForm.level, //档位
      // UUID: this.deviceRegisterForm.UUID,//uuid
    };
    if (submit.remark === "" || submit.model === "" || submit.level === "") {
      alert("error submit!!");
    } else {
      const res:any = await axios.post('device/device_register/', submit)

      if (res?.data == 'Unknown device model.') {
        (this.$refs.registerDeviceRef as any).show()
      } else {
        await this.onPaging(this.record, 1);
      }
      
      this.handleRegisterForm = false;
    }
  }
}
